import { Reveal } from "@/components/Reveal";

const STEPS = [
  {
    num: "01",
    title: "We understand your business",
    desc: "A straightforward conversation about your services, your customers and the areas you cover.",
  },
  {
    num: "02",
    title: "We build your digital presence",
    desc: "Your website, Google profile and social channels — designed, built and launched for you.",
  },
  {
    num: "03",
    title: "We connect your enquiry system",
    desc: "Forms, click-to-call, WhatsApp and notifications, all routed so no enquiry gets missed.",
  },
  {
    num: "04",
    title: "We automate and optimise",
    desc: "Automatic replies, follow-ups and ongoing refinements that keep enquiries flowing.",
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" data-testid="how-it-works-section" className="py-20 sm:py-28">
      <div className="section-shell">
        <Reveal>
          <p className="micro-label">How It Works</p>
          <h2 className="mt-4 font-heading text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight text-white max-w-2xl">
            A simple four-stage process — no jargon, no fuss
          </h2>
        </Reveal>
        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {STEPS.map((s, i) => (
            <Reveal key={s.num} delay={0.08 * i}>
              <div data-testid={`process-step-${s.num}`} className="card-hover relative h-full rounded-2xl border border-sky-500/12 bg-navy-900/70 p-7">
                <span className="font-mono text-4xl font-semibold text-sky-500/25">{s.num}</span>
                <h3 className="mt-5 font-heading text-lg font-bold text-white tracking-tight">{s.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-400">{s.desc}</p>
                {i < STEPS.length - 1 && (
                  <span className="hidden lg:block absolute top-1/2 -right-[13px] w-5 border-t border-dashed border-sky-500/30" />
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
